<script lang="ts">
    import { _, locale, locales } from "svelte-i18n";
    import { GlobalLine } from "svelte-remixicon";
    import { getLang } from "../helpers/i18n";
    import { Router, Link } from "svelte-routing";
    import { MenuLine, CloseLine } from "svelte-remixicon";

    let mobMenu = false;

    let langs = [];
    for (let i = 0; i < $locales.length; i++) {
        langs.push({ lang: $locales[i], key: i + 1 });
    }

    let lang = getLang();
    function changeLang(event) {
        locale.set(event.target.textContent.toLowerCase());
        lang = getLang();
    }

    function toggleMenu() {
        mobMenu = mobMenu != true;
    }

    function handleResize() {
        if (window.outerWidth > 768) {
            mobMenu = false;
        }
    }

    function getProps({ location, href, isPartiallyCurrent, isCurrent }) {
        const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;

        // The object returned here is spread on the anchor element's attributes
        if (isActive) {
            return { class: "active" };
        }
        return {};
    }
</script>

<svelte:window on:resize={handleResize} />

<Router>
    <div class="bg-secondary z-10">
        <div class="h-full mx-4 md:container flex">
            <div class="w-1/2 h-full flex flex-wrap justify-between">
                <div class="w-full flex items-start justify-start mt-3">
                    <Link to="/">
                        <div class="md:h-full flex items-center" on:click={() => {mobMenu = false}}>
                            <img class="md:h-[4.6rem]" src="/assets/images/edir-logo.png" alt="edirectory logo" />
                        </div>
                    </Link>
                </div>
                <div class="w-full hidden md:flex items-end justify-start mb-8">
                    <ul class="links">
                        <li class="cursor-pointer">
                            <Link to="search" getProps="{getProps}">{$_("nav.pages.search")}</Link>
                        </li>
                        <li class="cursor-pointer">
                            <Link to="support" getProps="{getProps}">{$_("nav.pages.support")}</Link>
                        </li>
                        <li class="cursor-pointer">
                            <Link to="about" getProps="{getProps}">{$_("nav.pages.about")}</Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="w-1/2 h-full flex items-start justify-end">
                <div class="hidden md:flex mt-4 items-center">
                    <span class="mr-1"><GlobalLine /></span>
                    {#each langs as locale}
                        <span
                                class="hover:text-red cursor-pointer
                                {lang == locale.lang
                                ? 'text-red'
                                : ''} {locale.key != langs.length
                                ? 'lang-link'
                                : ''}"
                                on:click={changeLang}
                        >{locale.lang.toUpperCase()}</span
                        >
                    {/each}
                </div>
                <div class="h-full flex md:hidden items-center">
                    {#if mobMenu}
                        <CloseLine size="32" on:click={toggleMenu} />
                    {:else}
                        <MenuLine size="32" on:click={toggleMenu} />
                    {/if}
                </div>
            </div>
        </div>
    </div>
    {#if mobMenu}
        <div class="z-20 w-full pb-3 bg-secondary mb:hidden" on:click={toggleMenu}>
            <ul class="text-center list-none">
                <li class="mob-link cursor-pointer">
                    <Link to="search">{$_("nav.pages.search")}</Link>
                </li>
                <li class="mob-link cursor-pointer">
                    <Link to="support">{$_("nav.pages.support")}</Link>
                </li>
                <li class="mob-link cursor-pointer">
                    <Link to="about">{$_("nav.pages.about")}</Link>
                </li>
            </ul>
            <div class="flex items-center flex-row justify-center">
                <span class="mr-1"><GlobalLine /></span>
                {#each langs as locale}
                        <span
                                class="hover:text-red cursor-pointer
                                {lang == locale.lang
                                ? 'text-red'
                                : ''} {locale.key != langs.length
                                ? 'lang-link'
                                : ''}"
                                on:click={changeLang}
                        >{locale.lang.toUpperCase()}</span
                        >
                {/each}
            </div>
        </div>
    {/if}
</Router>

<style windi:preflights>
    .lang-link {
        @apply after:content-["|"] after:text-red after:px-1;
    }

    .links {
        @apply list-none m-0 p-0 border-b-4 border-red ml-[-400px]  pl-[400px];
    }

    .links li {
        @apply inline text-[22px] mr-5 last:mr-0 hover:text-red;
    }

    .mob-link {
        @apply my-3 text-lg;
    }
</style>
